var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"justify-space-between":"","align-center":""}},[_c('div',{staticClass:"text-body-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-switch',{staticClass:"mt-0",attrs:{"input-value":_vm.value,"disabled":_vm.disabled,"hide-details":""},on:{"change":_vm.emitChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }